"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const JkcCheckBox = (props) => {
    const { name, settings, onChangeEvent } = props;
    const checkRef = (0, react_1.useRef)();
    let labelStyle = {
        marginBottom: "0px",
        position: settings.isNormalLabel ? "relative" : "absolute",
    };
    let checkboxLabelStyle = {
        clear: "none",
        padding: "0px 12px 0px 4px",
        marginBottom: "0px",
        lineHeight: settings.inputStyle.height,
        display: "flex",
        alignItems: "center",
    };
    let inputStyle = {
        width: "100%",
        padding: "5px",
        fontSize: "15px",
        border: "1px solid #D3D3D3",
        outline: "none",
        textAlign: "left",
        display: "flex",
        alignItems: "center",
    };
    (0, react_1.useEffect)(() => {
        if (settings.pointerColor) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-pointer-color", settings.pointerColor);
        }
        if (settings.pointerWidth) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-pointer-width", settings.pointerWidth);
        }
        if (settings.pointerHeight) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-pointer-height", settings.pointerHeight);
        }
        if (settings.pointerMargin) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-pointer-margin", settings.pointerMargin);
        }
        if (settings.checkboxCheckedBorderColor) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-checked-border-color", settings.checkboxCheckedBorderColor);
        }
        if (settings.checkboxUncheckedBorderColor) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-unchecked-border-color", settings.checkboxUncheckedBorderColor);
        }
        if (settings.checkboxCheckedBgColor) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-checked-bg-color", settings.checkboxCheckedBgColor);
        }
        if (settings.checkboxUncheckedBgColor) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-unchecked-bg-color", settings.checkboxUncheckedBgColor);
        }
        if (settings.checkboxBorder) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-border", settings.checkboxBorder);
        }
        if (settings.checkboxRadius) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-border-radius", settings.checkboxRadius);
        }
        if (settings.checkboxHeight) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-height", settings.checkboxHeight);
        }
        if (settings.checkboxWidth) {
            checkRef.current.style.setProperty("--smartjkc-checkbox-width", settings.checkboxWidth);
        }
    }, []);
    let fieldStyle = {
        position: "relative",
        width: "100%",
        display: settings.fieldTypes == "Grid" ? "flex" : "block",
        borderTop: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        borderBottom: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        marginTop: "-1px",
    };
    if (settings.fieldTypes == "Grid") {
        fieldStyle.alignItems = "center";
    }
    let fieldLablStyle = {
        width: settings.fieldTypes == "Grid" ? "30%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
    };
    let fieldInputStyle = {
        width: settings.fieldTypes == "Grid" ? "70%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
        borderLeft: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        position: "relative",
    };
    if (settings.fieldTypes == "Grid") {
        fieldLablStyle.textAlign = "right";
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldStyle, ref: checkRef, className: "component-area-cn" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldLablStyle }, { children: !settings.hideLabel ? ((0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, labelStyle), settings.labelStyle), htmlFor: name }, { children: settings.label ? settings.label : "Label" }))) : null })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldInputStyle }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: Object.assign(Object.assign({}, inputStyle), settings.inputStyle), className: `${settings.className}` }, { children: settings.json.map((element, i) => {
                        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "samrtjkcCheckboxbutton", style: settings.inline
                                ? { display: "inline-flex", alignItems: "center" }
                                : { display: "flex", alignItems: "center" } }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", className: settings.className, style: {
                                        width: "23px",
                                        height: "23px",
                                    }, name: element.value, onChange: onChangeEvent, checked: element.checked, value: element.value, id: element.value }), (0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, checkboxLabelStyle), settings.checkboxLabelStyle), htmlFor: element.value }, { children: element.name }))] }), i));
                    }) })) }))] })));
};
exports.default = JkcCheckBox;
